import { render, staticRenderFns } from "./ZoomableImage.vue?vue&type=template&id=1331edf0"
import script from "./ZoomableImage.vue?vue&type=script&lang=ts"
export * from "./ZoomableImage.vue?vue&type=script&lang=ts"
import style0 from "./ZoomableImage.vue?vue&type=style&index=0&id=1331edf0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports